import {
	login,
	logout,
	getInfo,
	organizationStation
} from '@/api/login'
import {
	getToken,
	setToken,
	removeToken
} from '@/utils/auth'
import Cookies from 'js-cookie'

const user = {
	state: {
		token: getToken(),
		name: '',
		avatar: '',
		roles: []
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		}
	},

	actions: {
		// 登录
		Login({
			commit
		}, userInfo) {
			const username = userInfo.loginName.trim()
			return new Promise((resolve, reject) => {
				login(username, userInfo.password, userInfo.captcha).then(response => {
					const data = response.data
					const tokenStr = data.token
					setToken(tokenStr)
					commit('SET_TOKEN', tokenStr)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 获取用户信息
		GetInfo({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				getInfo().then(response => {
					const data = response.data
					console.log(data, "data")
					if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
						if (data.roles[0].name == '超级管理员') {
							Cookies.set('roleType', 1);
						} else if (data.roles[0].name == '电话员') {
							Cookies.set('roleType', 2);
						} else if (data.roles[0].name.indexOf('站点') != -1) {
							Cookies.set('roleType', 3);
						}
						Cookies.set('roleId', data.roles[0].id);
						if (data.roles[0].name != '超级管理员' && data.departmentId) {
							organizationStation(data.departmentId).then(res => {
								if (res.data && res.data.id) {
									Cookies.set('roleType', 3);
									Cookies.set('stationId', res.data.id)
								}
							})
						}
						commit('SET_ROLES', data.roles)
					} else {
						reject('getInfo: roles must be a non-null array !')
					}
					commit('SET_NAME', data.name)
					commit('SET_AVATAR', data.headImage)
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 登出
		LogOut({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {

				commit('SET_TOKEN', '')
				commit('SET_ROLES', [])
				removeToken()
				resolve()
				// logout(state.token).then(() => {
				//   commit('SET_TOKEN', '')
				//   commit('SET_ROLES', [])
				//   removeToken()
				//   resolve()
				// }).catch(error => {
				//   reject(error)
				// })
			})
		},

		// 前端 登出
		FedLogOut({
			commit
		}) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '')
				removeToken()
				resolve()
			})
		}
	}
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js